import styled from 'styled-components'

export const CustomSpacing = styled.div`
    margin-top: 2rem;
`
